import '../scss/app.scss';
import './Components/E-icon/e-icon';
// Nicht praesenz-gesteuert: die Kampagnen-Parameter muessen auf jeder Seite
// erfasst werden, auch wenn dort kein Formular liegt (DLYE-4872).
import './Components/Form/utm-params';

if (document.querySelector('[data-fancybox]')) {
  import('@fancyapps/ui/dist/fancybox/fancybox.css');
  import(/* webpackChunkName: "Libs/fancybox" */ '@fancyapps/ui').then(({ Fancybox }) => {
    Fancybox.bind();
  });
}
if (document.querySelector('page-bar')) {
  import(/* webpackChunkName: "Components/PageBar/page-bar" */ './Components/PageBar/page-bar');
}

if (document.querySelector('page-mainnav')) {
  import(/* webpackChunkName: "Components/PageMainNav/mainnav" */ './Components/PageMainNav/mainnav');
}

if (document.querySelector('page-mobilenav')) {
  import(/* webpackChunkName: "Components/PageMobileNav/page-mobilenav" */ './Components/PageMobileNav/page-mobilenav');
}

if (document.querySelector('page-language')) {
  import(/* webpackChunkName: "Components/PageLanguage/page-language" */ './Components/PageLanguage/page-language');
}

if (document.querySelector('e-slider')) {
  import(/* webpackChunkName: "Components/E-slider/e-slider" */ './Components/E-slider/e-slider');
}

if (document.querySelector('e-tab')) {
  import(/* webpackChunkName: "Components/E-tab/e-tab" */ './Components/E-tab/e-tab');
}
if (document.querySelector('e-masonry')) {
  import(/* webpackChunkName: "Components/E-tab/e-tab" */ './Components/E-masonry/e-masonry');
}
if (document.querySelector('e-calculator')) {
  import(/* webpackChunkName: "Components/E-calculator/e-calculator" */ './Components/E-calculator/e-calculator');
}
if (document.querySelector('e-radius')) {
  import(/* webpackChunkName: "Components/E-radius/e-radius" */ './Components/E-radius/e-radius');
}
if (document.querySelector('e-map')) {
  import(/* webpackChunkName: "Components/E-map/e-map" */ './Components/E-map/e-map');
}
if (document.querySelector('e-downloadcenter')) {
  import(/* webpackChunkName: "Components/E-downloadcenter/e-downloadcenter" */ './Components/E-downloadcenter/e-downloadcenter');
}

if (document.querySelector('.teaser__video')) {
  import(/* webpackChunkName: "Components/Teaser/video" */ './Components/Teaser/video');
}

if (document.querySelector('.select-wrapper')) {
  import(/* webpackChunkName: "Components/Form/form" */ './Components/Form/form');
}

if (document.querySelector('e-interstitial')) {
  import(/* webpackChunkName: "Components/E-interstitial/e-interstitial" */ './Components/E-interstitial/e-interstitial');
}

if (document.querySelector('e-interstitial-modal')) {
  import(/* webpackChunkName: "Components/E-interstitial-modal/e-interstitial-modal" */ './Components/E-interstitial-modal/e-interstitial-modal');
}
